import React from 'react';

/**
 * DisplayMecanism
 * Props:
 *   mecanism: {
 *     type: string,
 *     unit: string,
 *     unitCondition?: number,
 *     reduction?: number
 *   }
 */
export default function DisplayMecanism({ mecanism }) {
  if (!mecanism) return <span>Aucun mécanisme</span>;

  const { type, unit, unitCondition, reduction } = mecanism;

  let description = '';

  switch (type) {
    case 'PRICE_DISCOUNT':
      description = `Remise de ${reduction}${unit === 'PERCENT' ? '%' : ''}`;
      if (unitCondition && unitCondition > 1) description += ` pour le ${unitCondition+1} article`;
      break;
    case 'BUY_X_GET_Y':
      description = `${unitCondition} acheté(s) ${reduction} offert(s)`;
      break;
    case 'BUY_X_SAVE_Y':
      description = `${unitCondition} acheté(s) et économisez ${reduction}${unit === 'PERCENT' ? '%' : ''}`;
      break;
    case 'FLAT':
      description = `Réduction fixe de ${reduction}`;
      break;
    default:
      description = `${type} (${unit}${unitCondition ? ', ' + unitCondition : ''}${reduction ? ', réduction : ' + reduction : ''})`;
  }

  return <span>{description}</span>;
}
